const tabs = [
  {
    subject: 'parent_status',
    type: 'is',
    value: 'all',
    text: 'All'
  },
  {
    subject: 'parent_status',
    type: 'is',
    value: 'current',
    text: 'Current'
  },
  {
    subject: 'parent_status',
    type: 'is',
    value: 'new',
    text: 'New'
  },
  {
    subject: 'parent_status',
    type: 'is',
    value: 'open',
    text: 'Open'
  },
  {
    subject: 'parent_status',
    type: 'is',
    value: 'on_hold',
    text: 'On Hold'
  },
  {
    subject: 'parent_status',
    type: 'is',
    value: 'rejected',
    text: 'Rejected'
  },
  {
    subject: 'parent_status',
    type: 'is',
    value: 'resolved',
    text: 'Resolved'
  }
]

export default tabs
